import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import React from 'react';
import CardHeader from 'react/shared/components/true_link/lab/form/wizard/CardHeader';
import theme from 'react/shared/theme/Theme';
import PALETTE from 'react/shared/theme/palette';
import api from 'react/signups/card/api';
import WizardCard from 'react/signups/card/common/WizardCard';
import { USER_TYPES } from 'react/signups/card/recipes/constants';

const useStyles = makeStyles(() => ({
  entryButton: {
    borderRadius: '4px',
    border: `1px solid ${PALETTE.emerald}`,
    padding: '20px',
    marginBottom: '15px',
    fontSize: '20px',
    '&:hover': {
      cursor: 'pointer',
      background: PALETTE.emeraldLight,
    },
  },
  primaryIcon: {
    marginRight: '20px',
    color: PALETTE.emerald,
    fontSize: '30px',
  },
  chevron: {
    color: PALETTE.emerald,
  },
  logInLink: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(4),
    },
  },
}));

export default function Manage({ setCardAccountSignup, setUserTypeData }) {
  const classes = useStyles();

  const handleContinue = (userType) => {
    setUserTypeData({ userType });

    if (userType !== 'myself') {
      const params = {
        card_account_signup: { userType },
      };
      api.createSignup(params).then((response) => {
        const cardAccountSignupFromResponse = response.data.data;
        const { attributes, id, relationships } = cardAccountSignupFromResponse;
        setCardAccountSignup({ id, relationships, ...attributes });
      });
    }
  };

  return (
    <>
      <WizardCard showBackButton>
        <CardHeader>{'Whose spending do you help manage?'}</CardHeader>
        <Paper
          className={classes.entryButton}
          onClick={() => handleContinue(USER_TYPES.FAMILY)}
          role="button"
        >
          <Box alignItems="center" display="flex" justifyContent="space-between">
            <Box alignItems="center" display="flex">
              <span className={classes.primaryIcon}>
                <i className="fa-solid fa-users" />
              </span>
              <span>A family member or loved one</span>
            </Box>
            <span className={classes.chevron}>
              <i className="fa-solid fa-angle-right" />
            </span>
          </Box>
        </Paper>
        <Paper
          className={classes.entryButton}
          onClick={() => handleContinue(USER_TYPES.CLIENT)}
          role="button"
        >
          <Box alignItems="center" display="flex" justifyContent="space-between">
            <Box alignItems="center" display="flex">
              <span className={classes.primaryIcon}>
                <i className="fa-solid fa-briefcase" />
              </span>
              <span>One or more clients</span>
            </Box>
            <span className={classes.chevron}>
              <i className="fa-solid fa-angle-right" />
            </span>
          </Box>
        </Paper>
        <Paper
          className={classes.entryButton}
          onClick={() => handleContinue(USER_TYPES.MYSELF)}
          role="button"
        >
          <Box alignItems="center" display="flex" justifyContent="space-between">
            <Box alignItems="center" display="flex">
              <span className={classes.primaryIcon}>
                <i className="fa-solid fa-user" />
              </span>
              <span>I need help managing my own spending</span>
            </Box>
            <span className={classes.chevron} id="survey-cta-for-my-own-spending">
              <i className="fa-solid fa-angle-right" />
            </span>
          </Box>
        </Paper>
      </WizardCard>
    </>
  );
}

Manage.propTypes = {
  setUserTypeData: PropTypes.func.isRequired,
  setCardAccountSignup: PropTypes.func.isRequired,
};
